/**
 * DOS518 — Integrazione ASTUTO
 * config.ts — Persistenza configurazione su localStorage.
 */

import type { AstutoConfig, AstutoMode } from './types';

const STORAGE_KEY = 'dos518_astuto_config';

export const DEFAULT_CONFIG: AstutoConfig = {
  mode: 'disabled',
  restTimeoutMs: 8000,
};

export function loadAstutoConfig(): AstutoConfig {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw
      ? { ...DEFAULT_CONFIG, ...(JSON.parse(raw) as Partial<AstutoConfig>) }
      : DEFAULT_CONFIG;
  } catch {
    return DEFAULT_CONFIG;
  }
}

export function saveAstutoConfig(config: AstutoConfig): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  } catch {
    // Silently ignore storage errors
  }
}

export function getActiveMode(): AstutoMode {
  return loadAstutoConfig().mode;
}
